import React from 'react';
import { Report } from 'cccisd-laravel-report';
import ExecutiveFunctionReport from '../Report';

const Component = props => {
    return (
        <div style={{ width: '840px', margin: '0 auto', maxWidth: '100%' }}>
            <Report downloadFilename="ExecutiveFunctionReport" height="600px">
                <ExecutiveFunctionReport {...props} />
            </Report>
        </div>
    );
};

export default Component;
